/**
 * URL of one entity search.
 *
 * One URL for every caller. The API decides from the session how wide the
 * query runs, so nothing here says or needs to know that.
 *
 * Takes no config, unlike {@link buildMembershipApiUrl}. It needs no `sessionId`
 * cache-buster, because the response is sent `Cache-Control: no-store` and so
 * has no cached body a later session could reuse; and it sends no `language`,
 * because the endpoint has none — a Common Org display name is not localized.
 */
export function buildOrgSearchUrl(
  baseUrl: string,
  partitionQueryParameter: string,
  query: string,
  limit: number
): string {
  const params = new URLSearchParams();
  // URLSearchParams encodes the query, so an entity name with an ampersand or a
  // plus in it cannot add a parameter of its own.
  params.set("q", query);
  params.set("limit", String(limit));
  params.set("partition", partitionQueryParameter);

  return `${baseUrl}/context/orgs/search/mine?${params.toString()}`;
}
